export default {
    toPay: 'К оплате',
    phone: 'Номер телефона',
    phonePlaceholder: '+7 (___) ___-__-__',
    sendCode: 'Отправить код',
    sending: 'Отправка...',
    smsCode: 'Код из SMS',
    changePhone: 'Изменить номер',
    confirm: 'Подтвердить',
    confirming: 'Проверка...',
    resendAfter: 'Повторная отправка через {n} сек.',
    resendText: 'Не пришла SMS?',
    resendLink: 'Отправить повторно',
    paymentConfirmed: 'Платёж подтверждён',
    redirecting: 'Выполняется переход...',
    errorSend: 'Не удалось отправить код. Попробуйте снова.',
    errorOtp: 'Неверный код. Попробуйте ещё раз.',
    invalidLink: 'Неверная ссылка',
    loadingTitle: 'Не удалось загрузить платёж',
    statusFallback: 'Неизвестная ошибка, обратитесь в поддержку',
    status_202: 'Операция успешно завершена',
    status_204: 'Операция уже была подтверждена ранее',
    status_206: 'Операция создана, PIN отправлен на телефон',
    status_208: 'PIN успешно повторно отправлен',
    status_300: 'Неизвестная ошибка, обратитесь в поддержку',
    status_601: 'Операция не найдена',
    status_602: 'Неверный PIN-код',
    status_603: 'Ошибка на стороне оператора, повторите позднее',
    status_604: 'Превышено время ожидания, повторите позднее',
    status_605: 'Недостаточно средств или ошибка резервирования',
    status_606: 'Ошибка списания, обратитесь в поддержку',
    status_607: 'Повторная отправка PIN выполняется слишком часто',
    status_608: 'Недостаточно баланса',
    status_609: 'Несуществующий абонент',
}
